import { QuotationMark, TestimonialsPattern } from "../assets";
import { ButtonLink } from "../components/Button";
import {
  // SecondaryTitleWrapper,
  SubtitleWrapper,
  TextShadeWrapper,
  TitleWrapper,
} from "../components/Wrappers";
import { AMAZON_STORE_LINK } from "../constants";

const Testimonials = () => {
  const TESTIMONIALS = [
    "Blockchain is not just a technology, it is a groundbreaking concept for decentralized money and finance. Monty Metzger has done something really important: showcasing the impact of that concept, revealing just how revolutionary it is.",
    "Blockchain  Banking  is  a  thought-provoking  and  timely  book  that offers  a  fresh  perspective  on  the  future  of  finance.  Monty's  deep knowledge of the industry and clear writing style make it a must-read for anyone interested in the intersection of blockchain and banking.",
    "Blockchain Banking is a fascinating and insightful book that provides a glimpse into the future of finance. The author's expert knowledge of the  industry  and  clear  writing  style  make  it  a  valuable  resource  for anyone looking to understand the potential of blockchain technology and how it can be used to transform the financial sector.",
    "Blockchain Banking is a must-read for anyone looking to understand the  opportunities  and  challenges  of  using  blockchain  technology  in the financial industry. The book provides a clear and concise overview  of  the  key  concepts,  and  offers  valuable  insights  into  how businesses  can  use  blockchain  to  create  new,  more  efficient  and more secure financial services.",
  ];
  return (
    <div className="testimonials">
      <div className="testimonials__header">
        <TitleWrapper
          maxWidth="338px"
          lineHeight="49px"
          maxWidthMd="100%"
          textAlignMd="center"
          textAlignSm="left"
        >
          What Readers Say <TextShadeWrapper>About the Book</TextShadeWrapper>
        </TitleWrapper>
        <SubtitleWrapper
          marginTop="20px"
          marginBottom="50px"
          maxWidth="407px"
          maxWidthMd="100%"
          textAlignMd="center"
          textAlignSm="left"
        >
          Let's hear what the readers have to say about this book! <br /> Let's
          hear what people who have read this book have to say about it.
        </SubtitleWrapper>

        <ButtonLink primaryBtn href={AMAZON_STORE_LINK} widthSm="100%">
          Write a review
        </ButtonLink>
      </div>
      <div className="testimonials__content">
        <img
          className="testimonials__bg-pattern-top"
          src={TestimonialsPattern}
          alt="bg-pattern"
        />
        {TESTIMONIALS.map((testimonials, i) => (
          <div key={i} className="testimonials__card">
            <img
              className="quotation-mark"
              src={QuotationMark}
              alt="quotation-mark"
            />
            <SubtitleWrapper
              fontSize="14px"
              lineHeight="25px"
              marginTop="15px"
              marginBottom="25px"
            >
              {testimonials}{" "}
            </SubtitleWrapper>
            {/* <SecondaryTitleWrapper lineHeight="16px">
              John Carter
            </SecondaryTitleWrapper>
            <SubtitleWrapper fontSize="14px" lineHeight="16px" marginTop="4px">
              Marketing Director at @Company
            </SubtitleWrapper> */}
          </div>
        ))}
        <img
          className="testimonials__bg-pattern-bottom"
          src={TestimonialsPattern}
          alt="bg-pattern"
        />
      </div>
    </div>
  );
};

export default Testimonials;
